module.exports = __webpack_public_path__ + "static/media/portfolio1 (53).5a6e5c02.jpeg";